import fetchService from 'common/actions/fetchService';
import i18n from 'common/locale/i18n';
import TemporarySystemDisruptionException from 'common/exceptions/TemporarySystemDisruptionException';

export const ACCOUNT_INFO_SET_USER_PROFILE = 'ACCOUNT_INFO_SET_USER_PROFILE';

export default function getUserProfile() {
  return function thunk(dispatch) {
    return dispatch(
      fetchService(({ pssService }) =>
        pssService.fetch(
          'POST',
          '/api/v2/busextranetoperator/account/getUserProfile',
          {}
        )
      )
    )
      .catch(() => {
        throw new TemporarySystemDisruptionException(
          i18n.getText('error_temporary_disruption_message'),
          {
            title: i18n.getText('error_temporary_disruption_title'),
          }
        );
      })
      .then(({ result }) => {
        return dispatch({
          type: ACCOUNT_INFO_SET_USER_PROFILE,
          payload: result.data,
        });
      });
  };
}
